// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Qziz","description":"PatientConsentPreview_description__3o9eY"};